import { useTranslation } from 'react-i18next';

import { Alert } from '@myphx-engineering/phx-design-system';

export const CodeExpiredError = () => {
    const { t } = useTranslation();
    return (
        <Alert data-testid="code-expired-error" severity="error">
            {t('formErrors.codeExpiredError.requestNew')}
        </Alert>
    );
};
